import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css';
import { setupPhoneClickTracking } from './utils/submitGuard';

setupPhoneClickTracking();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);